import React from "react";
import { AppData } from "../types/app";

// 아이콘 이미지가 없으면 이름 첫 글자 박스로 그린다. 크기는 className의 CSS가 정한다.
export default function AppIcon({ app, className = "" }: { app: AppData; className?: string }) {
  return (
    <span className={`app-icon ${className}`} aria-hidden="true">
      {app.icon ? <img src={app.icon} alt="" width={112} height={112} loading="lazy" /> : app.name.charAt(0)}
    </span>
  );
}
